<script setup lang="ts">
import { AssetType } from '~/apiClient';

// COMPOSABLES
const { formatSlpRoute } = useSlpRouteUtils();
const { onSlpFilterChangeByKey } = useTracking();
const { tt } = useTypedI18n();
const sellingMethod = useSlpSellingMethod();
const {
    // Filters
    brandIds,
    brandName,
    singleSelectedBrandId,
    modelId,

    // Options
    brandsOptions,
    modelsOptions,
} = useSlpParams(sellingMethod);

// DATA
const isSingleBrandSelected = computed(() => singleSelectedBrandId.value !== undefined);

const modelIdSelectModel = adaptEmptyOptionModel(modelId);
const modelsSelectOptions = computed(() => prependEmptyOption(modelsOptions.value, tt('slp.filters.modelFilterAnyOption')));
</script>

<template>
    <UFormField :label="tt('slp.filters.brandFilter')" class="sm:grow">
        <USelectMenu
            v-model="brandIds"
            multiple
            :disabled="brandsOptions.length === 0"
            :items="brandsOptions"
            :placeholder="tt('slp.filters.brandFilterAnyOption')"
            value-key="value"
        />
        <template v-for="brand in brandsOptions" :key="brand.value">
            <NuxtLinkLocale
                :to="
                    formatSlpRoute({
                        sellingMethod,
                        assetType: AssetType.Bus,
                        brandUrlKey: brand.urlKey,
                    })
                "
                class="hidden"
            >
                {{ brand.label }}
            </NuxtLinkLocale>
        </template>
    </UFormField>
    <UFormField :label="tt('slp.filters.modelFilter')" class="sm:grow">
        <USelectMenu
            v-model="modelIdSelectModel"
            :disabled="!isSingleBrandSelected || modelsOptions.length === 0"
            :items="modelsSelectOptions"
            value-key="value"
            @update:model-value="onSlpFilterChangeByKey('model', modelsSelectOptions, $event)"
        />
        <template v-if="isSingleBrandSelected">
            <template v-for="model in modelsOptions" :key="model.value">
                <NuxtLinkLocale
                    :to="
                        formatSlpRoute({
                            sellingMethod,
                            assetType: AssetType.Bus,
                            brandUrlKey: model.brandUrlKey,
                            modelUrlKey: model.urlKey,
                        })
                    "
                    class="hidden"
                >
                    {{ brandName }} {{ model.label }}
                </NuxtLinkLocale>
            </template>
        </template>
    </UFormField>
</template>
